function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { DeviceType } from '@sky-uk-ott/client-lib-js-device';
import { CoreVideoInternal } from '../core-video-internal';
import { PlayerState } from '../core/player/player-state';
import { sdkLogger } from '../logger';
import { Observable } from './observables/observable';
import { isWebOsVeryLowPoweredDevice } from './device-type';
import { InterpolationStrategies } from './utils.enums';
import { getTimeNow } from './time-util';
export { InterpolationStrategies } from './utils.enums';
var DEFAULT_POSITION_UPDATE_INTERVAL_LOW_END = 1;
var DEFAULT_POSITION_UPDATE_INTERVAL = 0.5;
// How far ahead the interpolated position gets before we slow it down, so the native position can catch up
var DECELERATION_THRESHOLD = 0.5;
var InterpolationStrategy = function InterpolationStrategy(isLive, positionUpdateFrequencySeconds) {
    "use strict";
    var interpolatedPositionSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    _class_call_check(this, InterpolationStrategy);
    _define_property(this, "isLive", void 0);
    _define_property(this, "positionUpdateFrequencySeconds", void 0);
    _define_property(this, "interpolatedPositionSeconds", void 0);
    _define_property(this, "logger", void 0);
    this.isLive = isLive;
    this.positionUpdateFrequencySeconds = positionUpdateFrequencySeconds;
    this.interpolatedPositionSeconds = interpolatedPositionSeconds;
    this.logger = sdkLogger.withContext('InterpolationStrategy');
};
var FullInterpolationStrategy = /*#__PURE__*/ function(InterpolationStrategy) {
    "use strict";
    _inherits(FullInterpolationStrategy, InterpolationStrategy);
    function FullInterpolationStrategy() {
        _class_call_check(this, FullInterpolationStrategy);
        var _this;
        _this = _call_super(this, FullInterpolationStrategy, arguments), _define_property(_this, "internalClockMultiplier", 1), _define_property(_this, "positionUpdateInterval", void 0), _define_property(_this, "lastNotifiedPositionChangedTimestamp", null), _define_property(_this, "hasGottenInitialPosition", false), _define_property(_this, "positionObservable", new Observable()), _define_property(_this, "lastTimeUpdate", null), _define_property(_this, "currentPlayerState", void 0);
        return _this;
    }
    _create_class(FullInterpolationStrategy, [
        {
            key: "onPositionUpdate",
            value: function onPositionUpdate(callback) {
                this.positionObservable.registerObserver(callback, this);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.positionUpdateInterval) {
                    this.stopUpdates();
                }
                this.positionObservable.unregisterObservers(this);
            }
        },
        {
            key: "handleNativePositionUpdated",
            value: function handleNativePositionUpdated(positionSeconds, forceUpdate) {
                if (!forceUpdate && this.shouldThrottleUpdate()) {
                    return;
                }
                this.lastTimeUpdate = getTimeNow();
                this.hasGottenInitialPosition = true;
                if (this.interpolatedPositionSeconds - positionSeconds > DECELERATION_THRESHOLD) {
                    // slow down internal clock so player catches up
                    this.internalClockMultiplier = 0.5;
                    return;
                } else if (this.interpolatedPositionSeconds >= positionSeconds) {
                    return;
                }
                this.internalClockMultiplier = 1;
                this.interpolatedPositionSeconds = positionSeconds;
                if (forceUpdate || this.positionUpdateInterval === undefined && this.currentPlayerState === PlayerState.Playing) {
                    this.startUpdates();
                }
            }
        },
        {
            key: "handleSeek",
            value: function handleSeek(positionSeconds) {
                // Let's save the seek pos in the next interpolation position since the
                // player state can change
                // to playing before we receive a position update from the player
                this.interpolatedPositionSeconds = Math.max(positionSeconds, 0);
                this.stopUpdates();
            }
        },
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {
                this.currentPlayerState = state;
                if (state !== PlayerState.Playing) {
                    this.stopUpdates();
                } else {
                    this.handlePlayingState();
                }
            }
        },
        {
            key: "msSinceLastUpdate",
            get: function get() {
                var _this_lastTimeUpdate;
                return getTimeNow() - ((_this_lastTimeUpdate = this.lastTimeUpdate) !== null && _this_lastTimeUpdate !== void 0 ? _this_lastTimeUpdate : 0);
            }
        },
        {
            key: "handlePlayingState",
            value: function handlePlayingState() {
                if (!this.isLive || this.hasGottenInitialPosition) {
                    this.startUpdates();
                }
            }
        },
        {
            key: "shouldThrottleUpdate",
            value: function shouldThrottleUpdate() {
                var intervalMs = this.positionUpdateFrequencySeconds * 1000;
                return this.lastTimeUpdate !== null && this.msSinceLastUpdate < intervalMs;
            }
        },
        {
            key: "startUpdates",
            value: function startUpdates() {
                var _this = this;
                clearInterval(this.positionUpdateInterval);
                // TODO position update callbacks can cause seeks through ad rules, which can cause state changes that lead to infinite
                // recursion as this function is called on state change. Prevent this possibility
                this.positionObservable.notifyObservers(this.interpolatedPositionSeconds);
                this.lastNotifiedPositionChangedTimestamp = getTimeNow();
                this.positionUpdateInterval = setInterval(function() {
                    _this.calculatePositionAndNotify();
                }, this.positionUpdateFrequencySeconds * 1000);
            }
        },
        {
            key: "calculatePositionAndNotify",
            value: function calculatePositionAndNotify() {
                var currentTime = getTimeNow();
                var timeDeltaSec = (currentTime - this.lastNotifiedPositionChangedTimestamp) / 1000;
                this.lastNotifiedPositionChangedTimestamp = currentTime;
                // if the JS thread is blocked for more than two ticks
                // then discard this particular update
                if (timeDeltaSec > this.positionUpdateFrequencySeconds * 2) {
                    return;
                }
                this.interpolatedPositionSeconds += timeDeltaSec * this.internalClockMultiplier;
                this.positionObservable.notifyObservers(this.interpolatedPositionSeconds);
            }
        },
        {
            key: "stopUpdates",
            value: function stopUpdates() {
                clearInterval(this.positionUpdateInterval);
                this.positionUpdateInterval = undefined;
            }
        }
    ]);
    return FullInterpolationStrategy;
}(InterpolationStrategy);
var ThrottledInterpolationStrategy = /*#__PURE__*/ function(InterpolationStrategy) {
    "use strict";
    _inherits(ThrottledInterpolationStrategy, InterpolationStrategy);
    function ThrottledInterpolationStrategy() {
        _class_call_check(this, ThrottledInterpolationStrategy);
        var _this;
        _this = _call_super(this, ThrottledInterpolationStrategy, arguments), _define_property(_this, "positionObservable", new Observable()), _define_property(_this, "lastTimeUpdate", null);
        return _this;
    }
    _create_class(ThrottledInterpolationStrategy, [
        {
            key: "destroy",
            value: function destroy() {
                this.positionObservable.unregisterObservers(this);
            }
        },
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {}
        },
        {
            key: "handleNativePositionUpdated",
            value: // nop
            function handleNativePositionUpdated(positionSeconds, forceUpdate) {
                if (!forceUpdate && this.shouldThrottleUpdate()) {
                    return;
                }
                this.lastTimeUpdate = getTimeNow();
                this.positionObservable.notifyObservers(positionSeconds);
            }
        },
        {
            key: "handleSeek",
            value: function handleSeek(positionSeconds) {}
        },
        {
            key: "onPositionUpdate",
            value: // nop
            function onPositionUpdate(callback) {
                this.positionObservable.registerObserver(callback, this);
            }
        },
        {
            key: "msSinceLastUpdate",
            get: function get() {
                var _this_lastTimeUpdate;
                return getTimeNow() - ((_this_lastTimeUpdate = this.lastTimeUpdate) !== null && _this_lastTimeUpdate !== void 0 ? _this_lastTimeUpdate : 0);
            }
        },
        {
            key: "shouldThrottleUpdate",
            value: function shouldThrottleUpdate() {
                var intervalMs = this.positionUpdateFrequencySeconds * 1000;
                return this.lastTimeUpdate !== null && this.msSinceLastUpdate < intervalMs;
            }
        }
    ]);
    return ThrottledInterpolationStrategy;
}(InterpolationStrategy);
var NoInterpolationStrategy = /*#__PURE__*/ function(ThrottledInterpolationStrategy) {
    "use strict";
    _inherits(NoInterpolationStrategy, ThrottledInterpolationStrategy);
    function NoInterpolationStrategy() {
        _class_call_check(this, NoInterpolationStrategy);
        return _call_super(this, NoInterpolationStrategy, [
            false,
            0
        ]);
    }
    _create_class(NoInterpolationStrategy, [
        {
            key: "handleNativePositionUpdated",
            value: function handleNativePositionUpdated(positionSeconds, forceUpdate) {
                this.positionObservable.notifyObservers(positionSeconds);
            }
        }
    ]);
    return NoInterpolationStrategy;
}(ThrottledInterpolationStrategy);
var getDevicePositionFrequencyOverride = function(deviceType, deviceInfo) {
    var _obj;
    var DEVICE_POSITION_FREQUENCY_OVERRIDE = (_obj = {}, _define_property(_obj, DeviceType.Chromecast, 0.5), _define_property(_obj, DeviceType.WebOS, isWebOsVeryLowPoweredDevice(deviceInfo) ? 5 : 0.333), _obj);
    return DEVICE_POSITION_FREQUENCY_OVERRIDE[deviceType];
};
export var InterpolatedPosition = /*#__PURE__*/ function() {
    "use strict";
    function InterpolatedPosition(param) {
        var strategy = param.strategy, isLive = param.isLive, positionEngine = param.positionEngine, positionUpdateFrequencySeconds = param.positionUpdateFrequencySeconds, isLowEndDevice = param.isLowEndDevice, startPosition = param.startPosition;
        _class_call_check(this, InterpolatedPosition);
        _define_property(this, "interpStart", void 0);
        _define_property(this, "positionEngine", void 0);
        this.positionEngine = positionEngine;
        var updateFreq = this.getPositionUpdateFrequency(positionUpdateFrequencySeconds, isLowEndDevice);
        if (strategy === InterpolationStrategies.FullInterpolation) {
            this.interpStart = new FullInterpolationStrategy(isLive, updateFreq, startPosition);
        } else if (strategy === InterpolationStrategies.JustThrottle) {
            this.interpStart = new ThrottledInterpolationStrategy(isLive, updateFreq);
        } else {
            this.interpStart = new NoInterpolationStrategy();
        }
        positionEngine.onStateChanged(this.handleStateChanged.bind(this), this);
    }
    _create_class(InterpolatedPosition, [
        {
            key: "onPositionUpdate",
            value: function onPositionUpdate(callback) {
                this.interpStart.onPositionUpdate(callback);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.interpStart.destroy();
                this.positionEngine.removeEventListeners(this);
            }
        },
        {
            key: "nativePositionUpdated",
            value: function nativePositionUpdated(positionSeconds, forceUpdate) {
                this.interpStart.handleNativePositionUpdated(positionSeconds, forceUpdate);
            }
        },
        {
            key: "handleSeek",
            value: function handleSeek(positionSeconds) {
                this.interpStart.handleSeek(positionSeconds);
            }
        },
        {
            key: "handleStateChanged",
            value: function handleStateChanged(state) {
                this.interpStart.handleStateChanged(state);
            }
        },
        {
            key: "getPositionUpdateFrequency",
            value: function getPositionUpdateFrequency(positionUpdateFrequencySeconds, isLowEndDevice) {
                if (positionUpdateFrequencySeconds) {
                    return positionUpdateFrequencySeconds;
                }
                var deviceDefaultValue = getDevicePositionFrequencyOverride(CoreVideoInternal.deviceType, CoreVideoInternal.deviceInfo);
                if (deviceDefaultValue) {
                    return deviceDefaultValue;
                }
                if (isLowEndDevice) {
                    return DEFAULT_POSITION_UPDATE_INTERVAL_LOW_END;
                } else {
                    return DEFAULT_POSITION_UPDATE_INTERVAL;
                }
            }
        }
    ]);
    return InterpolatedPosition;
}();

//# sourceMappingURL=interpolated-position.js.map